"use strict";

angular.module("core")
.service("InvoiceStatusFilterService", function($resource, gettextCatalog, InvoiceService, appConfig) {
    var resource = $resource(appConfig.API_SERVER + "/invoice/status-names/filters/dynamic/", {}, {
        query: {
            method: "get",
            isArray: true,
            ignoreLoadingBar: true
        }
    });

    this.query = function(filter) {
        var filterParams = filter ? filter : {};
        return resource.query(filterParams);
    };

    this.getStatusName = function(status) {
        var statuses = InvoiceService.getStatusFilterValues();
        return statuses[status];
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/invoice-status-filter/invoice-status-filter.service.js
// module id = 444
// module chunks = 0